const props = {
  /** the container flips on click */
  click: Boolean,
  /**the component is currently flipped */
  flipped: Boolean,
  /** the container flips on hover */
  hover: Boolean,
  /** the card flips vertically */
  vertical: Boolean,
  /** the card flips vertically */
  horizontal: Boolean,
};

export default props;
